import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Topbar } from '@/components/layout/Topbar';
import { Sidebar } from '@/components/layout/Sidebar';
import { NotificationsProvider } from '@/notifications/NotificationsContext';
import './AppShell.css';

/**
 * The authenticated shell — topbar + role-aware sidebar + routed content.
 * 08-staff-ux.md §2.
 *
 * `NotificationsProvider` (T115) is mounted HERE rather than at the app root: `AppShell` only ever
 * renders once `ProtectedRoute` has confirmed an authenticated session, so mounting here is a
 * reliable "auth is available" boundary — the notifications socket connects on mount and is torn
 * down on unmount (logout navigates away from `AppShell` entirely). It also needs to sit inside
 * the router (for `useNavigate`, used by the toast-on-arrival click handler and future row
 * navigation), which an app-root placement above `RouterProvider` would not allow.
 */
export function AppShell() {
  const [isNavOpen, setIsNavOpen] = useState(false);

  return (
    <NotificationsProvider>
      <div className="fa-app-shell">
        <Topbar onToggleNav={() => setIsNavOpen((v) => !v)} />
        <Sidebar isOpen={isNavOpen} onClose={() => setIsNavOpen(false)} />
        <main className="fa-app-shell__content">
          <Outlet />
        </main>
      </div>
    </NotificationsProvider>
  );
}
